<template>
    <div class="nav_right animate__animated animate__fadeInDown">
		<div class="mlogo_line">
			<div class="mlogo">
				<img :src="logoBM" alt="logo" @click="goHome()" />
			</div>

			<div class="mclose" @click="closeMobileMenu">
				<img src="@/assets/static/imgs/common/m/times.png" alt="Close Menu" />
			</div>
		</div>

        <div class="open-area">
            <div class="area-left-wrapper">
				<div class="area-left">
					<div 
						class="area-left-item" :class="{ active: currentOpenMenuIndex === index }" 
						v-for="(item, index) in openMenu" :key="item.tit" 
						v-if="index > 0" 
						@click="showGameFromTypeRight(index)">
						<div><img :src="item.img" alt=""></div>
						<div>{{ item.tit }}</div>
					</div>
				</div>
            </div>

            <div class="area-right">
                <div 
                    class="right-content right-content-0" 
                    v-for="i in openMenu.length" :key="i" 
                    v-if="(i-1) === currentOpenMenuIndex">
                    <div class="img-box">
                        <div 
                            class="img-block" 
                            v-for="(jItem, idx) in allGamesRight.slice(0, 15)" :key="currentOpenMenuIndex + '-' + idx + '-' + jItem.game_id" 
                            @click="gotoGameDetail(jItem.game_id)">
                            <img :src="jItem.icon" alt="" />
                            <div v-if="false">{{ jItem.game_name_cn }}</div>
                        </div>
                    </div>

                    <div class="btn-box">
                        <button @click="gotoAllGames">
                            {{ $t('index.btn_all_games') }} <img src="@/assets/static/imgs/common/arrow-white.png" alt="">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * Common Right Contact Us
 */
/* import contactWechatImg  from '@/../public/static/imgs/wechat/summer.png';
import contactDemoAppImg from '@/../public/static/imgs/wechat/demo-app.png'; */
import logoFileBM          from '@/assets/static/imgs/common/m/logo-b-m.png';
import { mapState }        from 'vuex';
import { MOBILE_MENU_FLAG} from '@/type/mutation';
import { goToHome }        from '@/utils/routerUtils';
import { fetchAllGamesCached } from '@/api/gameDataLoader';
import { getDemoQrCodeImages } from '@/utils/qrCodeConfig';

export default {
    name : 'RightMenuContent',
    data() {
        return {
            // contactWechatImg,
            // contactDemoAppImg,
            iconObj: {
				icon_email      : require('@/assets/static/imgs/common/icon-email.png'),
				icon_tel        : require('@/assets/static/imgs/common/icon-tel.png'),
				qr_contact      : require('@/assets/static/imgs/common/qr-contact.png'),
				float_icon_chat : require('@/assets/static/imgs/common/float_icon_chat.png'),
				icon_google_play: require('@/assets/static/imgs/common/icon-google-play.png'),
				icon_ios        : require('@/assets/static/imgs/common/icon-ios.png'),
				...getDemoQrCodeImages(),
				float_icon_demo : require('@/assets/static/imgs/common/float_icon_demo.png')
			},
            currentOpenMenuIndex: 1,
			openMenu            : [
				{
					img: require('@/assets/static/imgs/common/m/icon_Global.png'),
					tit: this.$t('index.sub_nav.tit_0')
				},
				{
					img: require('@/assets/static/imgs/common/m/icon_Global.png'),
					tit: this.$t('index.sub_nav.tit_1')
				},
				{
					img: require('@/assets/static/imgs/common/m/icon_MiddleEast.png'),
					tit: this.$t('index.sub_nav.tit_2')
				},
				{
					img: require('@/assets/static/imgs/common/m/icon_America.png'),
					tit: this.$t('index.sub_nav.tit_3')
				},
				{
					img: require('@/assets/static/imgs/common/m/icon_SoutheastAsia.png'),
					tit: this.$t('index.sub_nav.tit_4')
				}
			],
            allGamesRight: [],
            allGamesLocal: []
        }
    },

    async created() {
        // 初始：缓存优先获取数据（若 App.vue 还未完成加载时确保可用）
        try {
            const games = await fetchAllGamesCached();
            this.allGamesLocal = games;
            this.allGamesRight = this.allGamesLocal.filter(game => Number(game.category) === 1);
            this.allGamesRight.sort((a, b) => Number(b.game_id) - Number(a.game_id));
            this.allGamesRight = this.allGamesRight.slice(0, 15);
        } catch (err) {
            console.error('=== RightMenuContent__created__load failed >>>', err);
        }
    },

    methods: {
        // 切换
		handleSelect(key, keyPath)
		{
			// console.log('=== key >>>', key, keyPath);
		},

		handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        },

        // 顶部导航菜单展开后：左侧子菜单 > 点击事件
		showGameFromTypeRight(index)
		{
			// 指定类别
			this.currentOpenMenuIndex = index;
			this.allGamesRight        = [];
			this.allGamesRight        = this.allGamesLocal.filter(
				game => Number(game.category) === Number(index)
			);

			// 排序
            switch (Number(index)) {
				case 1: // 休闲互动
				case 2: // 经典棋牌
				case 3: // 语音游戏
				case 4: // 弹幕游戏
                    this.allGamesRight.sort((a, b) => Number(b.game_id) - Number(a.game_id));
					break;
				default:
					break;
			}

			// 截取
			this.allGamesRight = this.allGamesRight.slice(0, 15);
		},

        // 跳转至首页
		goHome()
		{
			// console.log('=== Open mobile menu, top logo click <<<');
			goToHome(this.$router);
		},

		// 跳转至全部游戏页
		gotoAllGames()
		{
			// console.log('=== Open mobile menu, btn All Games click <<<');
			this.closeMobileMenu();
			this.$router.push('/allgames');
		},

		// 跳转至游戏详情页
		gotoGameDetail(currentGameId)
		{
			// console.log('=== nav__gotoGameDetail__currentGameId >>>', currentGameId);
			this.closeMobileMenu();
			let sign = this.$Common.makeSign(this, currentGameId);
			this.$router.push({
				path: `/gamedetail/${currentGameId}/${sign}`
			});
		},

		// 关闭移动端菜单
		closeMobileMenu()
		{
			// console.log('=== App__closeMobileMenu >>>', 1);
			this.$store.commit(MOBILE_MENU_FLAG, false);
		}
	},

    computed: {
		// ES6展开合并运算符
		...mapState([
			'isNavBgColorful', 
			'isShowMobileMenu'
		]),

		/**
		 * 判断：是否移动端设备
		 * true-移动端, false-PC端
		 */
		isM()
		{
			return this.$Common.isMobile();
		},

		// LOGO
		logoBM()
		{
			return logoFileBM;
		}
	}
}
</script>

<style lang="less" scoped>
.nav_right{
	z-index:11;
    position:fixed;top:0;left:0;right:0;margin:auto;
	background:#FFF;
	.mlogo_line{
		width:100%;height:100px;
		display:flex;justify-content:space-between;align-items:center;
		.mlogo{
			width:200px;height:70px;
			display:flex;justify-content:center;align-items:center;
			img{
				width:142px;height:60px;
			}
		}
		.mclose{
			width:90px;height:70px;
			display:flex;justify-content:center;align-items:center;
			img{
				width:38px;height:38px;
			}
		}
	}
	.open-area{
		display:flex;justify-content:center;align-items:flex-start;
		height:calc(100vh - 100px);
		.area-left-wrapper{
			width:250px;height:100%;
			background:#FAFCFE;
			.area-left{
				width:100%;height:400px;
				background:#FAFCFE;
				display:flex;flex-direction:column;justify-content:center;align-items:center;
				gap:30px;
				.area-left-item{
					display:flex;justify-content:flex-start;align-items:center;
					width:100%;height:50px;
					padding-left:6px;
					border-left:4px solid #FFF;
					img{
						width:48px;height:48px;
					}
					div:nth-child(2){
						font-size:var(--com-base-fz-24);font-weight:bold;
					}
					&.active{
						border-left:4px solid #1C55FF;
					}
				}
			}
		}
		.area-right{
			width:500px;height:100%;
			.right-content{
				position:relative;
				width:100%;height:100%;
				padding-top:50px;
				.img-box{
					width:100%;
					display:flex;justify-content:center;align-items:flex-start;flex-wrap:wrap;
					gap:15px;
					.img-block{
						width:130px;height:130px;
						margin-bottom:30px;
						img{
							width:inherit;height:inherit;
						}
					}
				}
				.btn-box{
					width:100%;height:88px;
					/* position:absolute;bottom:150px; */
					display:flex;justify-content:center;align-items:center;
					margin-top:50px;
					button{
						width:310px;height:88px;
						border-radius:44px;border:none;outline:none;
						background:#252525;
						font-size:var(--com-base-fz-28);color:#FFF;text-align:center;font-weight:bold;
						cursor:pointer;
						img{
							width:26px;height:22px;
						}
					}
				}
			}
		}
	}
}
</style>
